import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  variants: {
    topMenu: {
      padding: "12px 12px",
      gap: 2,
      bg: "primary.black.5",
      color: "primary.black.100",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      fontSize: "16px",
      lineHeight: "24px",
      rounded: "24px",
      _hover: { bg: "primary.black.10" },
    },
    primary: {
      bg: "primary.red.100",
      color: "primary.white.100",
      _hover: { bg: "landing.red" },
      _disabled: { _hover: { bg: "#FA5470 !important" } },
    },
    disabled: {
      bg: "primary.black.20",
      color: "primary.white.100",
      _hover: "primary.black.20",
      opacity: "1 !important", // need to override default chakra style
    },
    secondary: {
      color: "primary.red.100",
      bg: "primary.white.100",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary.red.100",
      _hover: {
        bg: "#FA5470",
        color: "primary.white.100",
        borderColor: "#FA5470",
      },
      _disabled: { _hover: { color: "#FA5470" } },
    },
    yellow: {
      color: "secondary.yellow",
      bg: "primary.black.100",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "secondary.yellow",
      borderRadius: "28px",
      _hover: {
        bg: "secondary.yellow",
        color: "primary.black.100",
        borderColor: "secondary.yellow",
      },
    },
    outline: {
      bg: "none",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary.black.100",
      borderRadius: "40px",
      _hover: {
        bg: "primary.black.100",
        color: "primary.white.100",
      },
    },
    primaryBlack: {
      bg: "primary.black.100",
      color: "stbtc.yellow",
      _hover: {
        bg: "primary.black.80",
      },
      _disabled: {
        _hover: {
          bg: "primary.black.100 !important",
        },
      },
    },
    blackWhite: {
      rounded: "40px",
      bg: "primary.black.100",
      color: "primary.white.100",
      _hover: {
        bg: "primary.black.80",
      },
    },
    defaultGray: {
      background: "primary.black.5",
      rounded: "16px",
      _hover: {
        color: "primary.red.100",
      },
      _disabled: {
        _hover: {
          color: "primary.black.100",
          background: "primary.black.5 !important",
        },
      },
    },
  },
  sizes: {
    medium: {
      padding: "8px 16px",
      rounded: "40px",
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      lineHeight: "24px",
      letterSpacing: "0.16px",
    },
    large: {
      padding: "16px 24px",
      rounded: "40px",
      fontSize: "24px",
      fontWeight: 700,
      fontFamily: "riforma.bold",
      lineHeight: "32px",
      letterSpacing: "0.24px",
    },
    smallSquare: {
      padding: "8px 12px",
      rounded: "4px",
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      lineHeight: "24px",
    },
  },
})

export default theme
